
import { Http } from '@/plugins/axios'
import { BasicInfo } from '@/store/info'
import { computed, defineComponent, onMounted, PropType, reactive } from 'vue'
import { useStore } from 'vuex'
import ChainTag from './ChainTag.vue'

export interface IRedPackBasicInfo {
  amount: string;
  chainId: string;
  decimal: number;
  denom: string;
  envelopeId: string;
  expiredDate: number;
  message: string;
  sendDate: number;
  sender: string;
  title: string;
}

export default defineComponent({
  components: { ChainTag },
  props: {
    redPackId: {
      type: String
    },

    chainId: {
      type: [Number, String],
      required: true
    },

    info: {
      type: Object as PropType<IRedPackBasicInfo>
    }
  },

  emits: ['ready'],

  setup (props, { emit }) {
    const store = useStore()

    // 币种信息
    const symbolInfo = reactive({
      logo: ''
    })

    const redPackBasicInfo = computed(() => {
      return store.state.info.basic
    })

    /**
     * 获取红包简短详情
     */
    async function getEnvelopeShort () {
      const data = await Http.get<IRedPackBasicInfo>({
        url: '/redenvelope/v1/envelope/short',
        params: {
          chainId: props.chainId,
          envelopeId: props.redPackId
        }
      })

      store.commit('info/SET_BASIC', {
        amount: data.amount,
        chainId: data.chainId,
        decimal: data.decimal,
        denom: data.denom,
        envelopeId: data.envelopeId,
        expiredDate: data.expiredDate,
        message: data.message,
        sendDate: data.sendDate,
        sender: data.sender,
        title: data.title
      } as BasicInfo)
    }

    async function getSymbolCmcInfo () {
      try {
        const data = await Http.get<{
          logo: string;
        name: string;
        symbol: string;
      }>({
        url: '/cmc/info',
        params: {
          symbol: redPackBasicInfo.value.denom
        }
      })

        symbolInfo.logo = data.logo
      } catch (error) {

      }
    }

    onMounted(async () => {
      if (props.redPackId) {
        await getEnvelopeShort()
      } else {
        if (props.info) {
          store.commit('info/SET_BASIC', {
            amount: props.info.amount,
            chainId: props.info.chainId,
            decimal: props.info.decimal,
            denom: props.info.denom,
            envelopeId: props.info.envelopeId,
            expiredDate: props.info.expiredDate,
            message: props.info.message,
            sendDate: props.info.sendDate,
            sender: props.info.sender,
            title: props.info.title
          } as BasicInfo)
        }
      }

      if (redPackBasicInfo.value.denom) {
        await getSymbolCmcInfo()
      }
    })

    return {
      symbolInfo,
      redPackBasicInfo
    }
  }
})
